<div class="image-modal-container">
	<div class="image-modal-header">
		<h2 class="image-modal-title" mat-dialog-title>
			{{ data.title }}
		</h2>
		<button
			mat-icon-button
			class="close-button"
			(click)="close()"
			aria-label="Cerrar imagen"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="image-modal-content" mat-dialog-content>
		<img
			[src]="data.imageSrc"
			[alt]="data.altText"
			class="modal-image"
			(error)="onImageError($event)"
		/>
	</div>

	<div class="image-modal-actions" mat-dialog-actions>
		<button
			mat-raised-button
			color="primary"
			(click)="close()"
			class="close-action-btn"
		>
			{{ "common.close" | translate }}
		</button>
	</div>
</div>
